module.exports = __webpack_public_path__ + "img/2-7-resorts-world.3e32669b.jpg";